import React from 'react';
import { Button, Table, Loader, Grid, Form, Icon, Popup } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import { FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema kreiranih grupa.</p>;

export default class StudentGroups extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            editMode: false,
            newName: null

        };
        this.deleteGroup = this.deleteGroup.bind(this);
        this.editName = this.editName.bind(this);
    }

    deleteGroup(id) {

        axios.delete(`course/groups/delete/${id}`)
            .then(res => {
                toast('Brisanje grupe je uspješno izvršeno.');
                this.props.getGroups(localStorage.getItem('groupType'), localStorage.getItem('courseImplementation'));
            })
            .catch(err => {
                if (err.response.data === 'Students are added to this group!') {
                    toast('Došlo je do greške! Grupu nije moguće obrisati jer postoje upisani studenti.');
                } else if (err.response.data === 'Exams are created for this group!') {
                    toast('Došlo je do greške! Grupu nije moguće obrisati jer postoji kreiran ispit.');
                } else if (err.response.data === 'Staff is added to this group!') {
                    toast('Došlo je do greške! Grupu nije moguće obrisati jer postoji dodano osoblje.');
                } else if (err.response.data === 'There are questionnaire answers from students for this group!') {
                    toast('Došlo je do greške! Grupu nije moguće obrisati jer je povezana sa anketama i postoje odgovori studentata.');
                } else if (err.response.data === 'Questionnaire statistics is created for this group!') {
                    toast('Došlo je do greške! Grupu nije moguće obrisati jer je kreirana statistika za anektu.');
                } else if (err.response.data === 'Staff questionnaire structure is created for this group!') {
                    toast('Došlo je do greške! Grupu nije moguće obrisati jer postoji kreiran izvještaj strukture uzoraka.');
                } else { toast('Došlo je do greške! Arhiviranje grupe nije uspješno izvršeno!'); }
            });
    }


    editName(id, optLock) {
        let obj = {
            id, optLock, name: this.state.newName
        };
        axios.put('course/groups/update', { ...obj })
            .then(res => {
                toast('Izmjena naziva grupe je uspješno izvršena.');
                this.setState({ editMode: false });
                this.props.getGroups(localStorage.getItem('groupType'), localStorage.getItem('courseImplementation'));
            })
            .catch(err => {
                toast('Došlo je do greške! Izmjena naziva grupe nije izvršena!');
            });
    }


    render() {
        if (!this.props.data) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                {localStorage.getItem('academicYearId') === localStorage.getItem('currentAcademicYearId') && <div></div>}
                {this.props.loader ? <div style={{ paddingTop: '50px' }}><Loader active inline="centered" /></div> :
                    this.props.data.length ?
                        <Table celled selectable compact>
                            <Table.Header>
                                <Table.Row>
                                    <Table.HeaderCell colSpan="2">
                                        Naziv grupe
                                    </Table.HeaderCell>
                                    <Table.HeaderCell></Table.HeaderCell>
                                </Table.Row>
                            </Table.Header>
                            <Table.Body> {this.props.data.map((el, index) =>
                                (<Table.Row key={el.id}>
                                    <Table.Cell verticalAlign="middle" colSpan="2">

                                        <Grid>
                                            <Grid.Column width={12} verticalAlign="middle" >
                                                {this.state.editMode === index ?
                                                    <Form>
                                                        <Form.Field >
                                                            <input
                                                                value={this.state.newName}
                                                                onChange={(e) => this.setState({ newName: e.target.value })}
                                                                name="input"
                                                            />
                                                        </Form.Field>
                                                    </Form>
                                                    : el.name
                                                }
                                            </Grid.Column>
                                            <Grid.Column width={4} textAlign="center">
                                                {this.state.editMode === index && <div><Popup
                                                    content="Sačuvaj"
                                                    position="top center"
                                                    trigger={<Button
                                                        basic="true"
                                                        circular
                                                        icon="check"
                                                        size="small"
                                                        color="blue"
                                                        onClick={() => this.editName(el.id, el.optLock)}
                                                    ></Button>}
                                                /><Popup
                                                    content="Odustani"
                                                    position="top center"
                                                    trigger={
                                                        <Button
                                                            basic="true"
                                                            circular
                                                            icon="delete"
                                                            size="small"
                                                            color="red"
                                                            onClick={() => this.setState({ editMode: false })}
                                                        >
                                                        </Button>}
                                                /></div>
                                                }
                                            </Grid.Column>
                                        </Grid>


                                    </Table.Cell>
                                    <Table.Cell textAlign="center">
                                        <Popup
                                            content="Spisak studenata"
                                            position="top center"
                                            trigger={
                                                <Link to={{
                                                    pathname: !this.props.examGroups ? '/studentske-grupe/studenti' : '/ispitne-grupe/studenti',
                                                    state: {
                                                        courseImplementationGroupId: el.id,
                                                        active: this.props.active,
                                                        groupName: el.name
                                                    }
                                                }}
                                                >
                                                    <Button
                                                        basic="true"
                                                        circular
                                                        icon="group"
                                                        size="small"
                                                        color="blue"
                                                    />
                                                </Link>}
                                        />
                                        <Popup
                                            content="Nastavno osoblje"
                                            position="top center"
                                            trigger={
                                                <Link to={{
                                                    pathname: !this.props.examGroups ? '/studentske-grupe/nastavno-osoblje' : '/ispitne-grupe/nastavno-osoblje',
                                                    state: {
                                                        courseImplementationGroupId: el.id,
                                                        active: this.props.active,
                                                        groupName: el.name
                                                    }
                                                }}
                                                >
                                                    <Button
                                                        basic="true"
                                                        circular
                                                        icon="user"
                                                        size="small"
                                                        color="teal"
                                                    />
                                                </Link>}
                                        />

                                        { this.props.active && localStorage.getItem('academicYearId') === localStorage.getItem('currentAcademicYearId') && <Popup
                                            content="Izmjena"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    basic="true"
                                                    color="green"
                                                    circular
                                                    icon="pencil alternative"
                                                    size="small"
                                                    onClick={() => this.setState({ editMode: index, newName: el.name })}
                                                />
                                            }
                                        />}

                                        { this.props.active && <Popup
                                            content="Brisanje"
                                            position="top center"
                                            trigger={<Button
                                                color="red"
                                                basic="true"
                                                circular
                                                icon="archive"
                                                size="small"
                                                onClick={() => this.deleteGroup(el.id)}
                                            ></Button>}
                                        />}

                                    </Table.Cell>
                                </Table.Row>))}
                            </Table.Body>
                        </Table>
                        : <div><br /><br /><NoDataMessage /></div>

                }
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentGroups/StudentGroups.js